import { render, staticRenderFns } from "./FileView.vue?vue&type=template&id=f3a4f338&scoped=true&"
import script from "./FileView.vue?vue&type=script&lang=js&"
export * from "./FileView.vue?vue&type=script&lang=js&"
import style0 from "./FileView.vue?vue&type=style&index=0&id=f3a4f338&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a4f338",
  null
  
)

export default component.exports